import React, { FC } from "react";
import { Stack, Typography } from "@mui/material";
import { Colors } from "@src/gatsby-theme-material-ui-top-layout/colors";

interface Props {
  content: string;
}

const Callout: FC<Props> = ({ content }) => {
  return (
    <Stack mb={3} sx={{ paddingRight: 5 }}>
      <Typography
        variant="h6"
        sx={{
          fontSize: "24px",
          lineHeight: "28px",
          fontWeight: "300",
          color: Colors.PrimaryMain,
        }}
      >
        {content}
      </Typography>
    </Stack>
  );
};

export default Callout;
